import type { ComponentPropsWithoutRef, ReactNode, Ref } from 'react'

import { cn } from '@gto/ui/cn'

import { groupedFieldVariants } from './grouped-field.styles'

export type GroupedFieldRootProps = ComponentPropsWithoutRef<'fieldset'> & {
  /** Group content. */
  children?: ReactNode
  /** Additional CSS class names. */
  className?: string
  /** Marks the grouped field as invalid for styling and assistive technology. */
  invalid?: boolean
  /** React 19 ref prop. */
  ref?: Ref<HTMLFieldSetElement>
}

export const Root = ({
  children,
  className,
  invalid = false,
  ref,
  'aria-invalid': ariaInvalid,
  ...props
}: GroupedFieldRootProps) => {
  const { root } = groupedFieldVariants()

  return (
    <fieldset
      ref={ref}
      aria-invalid={ariaInvalid ?? (invalid ? true : undefined)}
      className={cn(root(), className)}
      data-invalid={invalid ? 'true' : undefined}
      {...props}
    >
      {children}
    </fieldset>
  )
}
